import React, { useEffect, useState } from 'react'
import Loader from '../../component/layout/Loader'
import { t } from 'i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../api/api';
import IconUserPlus from '../../component/icon/IconUserPlus';
import IconSearch from '../../component/icon/IconSearch';


const HomeworkList = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(false)
    const [notiifications, setNotifications] = useState<any>([])
    const [tabCounts, setTabCounts] = useState({ active: 0, rate: 0, close: 0 })
    
    // Get current filter from URL params
    const currentFilter = searchParams.get('filter') || 'active'

    const fetchHomework = () => {
        setLoading(true)
        // Add filter parameter to API call
        const filterParam = currentFilter ? `?status=${currentFilter}` : ''
        api.get(`${process.env.REACT_APP_API_BASE_URL}/homework/coach${filterParam}`).then(res => {
        setLoading(false)
            console.log("notification", res.data.data)
            setNotifications(res.data.data.data)
            
            // Use the counts from API response
            const activeCount = res.data.data.active_is_submission_seen_count || 0
            const rateCount = res.data.data.rate_is_submission_seen_count || 0
            const closeCount = 0 // Keep close count as 0 since API doesn't provide this
            
            setTabCounts({ active: activeCount, rate: rateCount, close: closeCount })
        }).catch(err => {
            setLoading(false)
            console.log("err cart", err)
        })
    }

    useEffect(() => {
        fetchHomework()
    }, [currentFilter])

    function formatDate(dateString: string) {
        const date = new Date(dateString)

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kuala_Lumpur',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        })

        const parts = formatter.formatToParts(date)
        const partMap = Object.fromEntries(parts.map(p => [p.type, p.value]))

        const formattedDate = `${partMap.day} ${partMap.month} ${partMap.year}`
        return formattedDate
    }

    // Handle filter button clicks
    const handleFilterChange = (filter: string) => {
        setSearchParams({ filter })
    }

    return (
        <>
        {loading && <Loader/>}
        <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex gap-2">
                <button 
                    type="button" 
                    onClick={() => handleFilterChange('active')}
                    className={`relative flex items-center gap-2 px-4 py-2 rounded-full border transition-colors ${
                        currentFilter === 'active' 
                            ? 'bg-primary text-white border-primary' 
                            : 'bg-white text-gray-600 border-gray-300'
                    }`}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    Active
                    {tabCounts.active > 0 && (
                        <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full min-w-[20px] h-5 flex items-center justify-center">
                            {tabCounts.active}
                        </span>
                    )}
                </button>
                
                <button 
                    type="button" 
                    onClick={() => handleFilterChange('rate')}
                    className={`relative flex items-center gap-2 px-4 py-2 rounded-full border transition-colors ${
                        currentFilter === 'rate' 
                            ? 'bg-primary text-white border-primary' 
                            : 'bg-white text-gray-600 border-gray-300'
                    }`}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>
                    </svg>
                    Rate
                    {tabCounts.rate > 0 && (
                        <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full min-w-[20px] h-5 flex items-center justify-center">
                            {tabCounts.rate}
                        </span>
                    )}
                </button>
                
                <button 
                    type="button" 
                    onClick={() => handleFilterChange('close')}
                    className={`relative flex items-center gap-2 px-4 py-2 rounded-full border transition-colors ${
                        currentFilter === 'close' 
                            ? 'bg-primary text-white border-primary' 
                            : 'bg-white text-gray-600 border-gray-300'
                    }`}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h4a1 1 0 110 2h-1v11a3 3 0 01-3 3H8a3 3 0 01-3-3V9H4a1 1 0 110-2h4zm2-2v2h4V5h-4zm6 4H8v10a1 1 0 001 1h8a1 1 0 001-1V9z"/>
                    </svg>
                    Closed
                    {tabCounts.close > 0 && (
                        <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full min-w-[20px] h-5 flex items-center justify-center">
                            {tabCounts.close}
                        </span>
                    )}
                </button>
            </div>
        </div>
        <div className="mt-5 space-y-6">
            {notiifications.map((branchData: any, branchIndex: number) => (
                <div key={branchIndex} className={branchIndex > 0 ? "border-t border-gray-200 pt-6" : ""}>
                    {/* Branch Header */}
                    <div className="bg-white rounded-3xl border border-gray-200 p-3 mb-4 shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex-1 min-w-0 pr-4">
                                <h3 className="text-base font-semibold text-black mb-1 truncate">
                                    {branchData.branch_name}
                                </h3>
                                <div className="text-sm text-gray-600 space-y-1">
                                    <p className="truncate">{branchData.day} & Class time - {branchData.start_time} - {branchData.end_time}</p>
                                    <p className="truncate">{branchData.course_name}</p>
                                </div>
                            </div>
                            <button 
                                type="button" 
                                onClick={() => navigate(`/homework/create?branch_id=${branchData.branch_id}&timeslot_schedule_id=${branchData.timeslot_schedule_id}&course_id=${branchData.course_id}`)}
                                className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center transition-colors"
                                title="Create Homework"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 4c.55 0 1 .45 1 1v6h6c.55 0 1 .45 1 1s-.45 1-1 1h-6v6c0 .55-.45 1-1 1s-1-.45-1-1v-6H5c-.55 0-1-.45-1-1s.45-1 1-1h6V5c0-.55.45-1 1-1z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    {/* Homework Cards for this branch */}
                    <div className="space-y-3">
                        {branchData.homeworks && branchData.homeworks.length > 0 ? (
                            branchData.homeworks.map((homework: any) => {
                                const getBorderColor = () => {
                                    switch (homework.status) {
                                        case 'GREEN': return 'border-l-primary'
                                        case 'YELLOW': return 'border-l-yellow-500'
                                        case 'RED': return 'border-l-red-500'
                                        case 'GREY': return 'border-l-gray-400'
                                        default: return 'border-l-gray-300'
                                    }
                                }
                                
                                return (
                                    <div 
                                        key={homework.id} 
                                        onClick={() => navigate(`/homework/${homework.id}`)} 
                                        className={`bg-white rounded-lg border-l-4 ${getBorderColor()} px-2 py-3 cursor-pointer hover:shadow-md transition-shadow relative`}
                                    >
                                        <div className="flex items-start justify-between">
                                            <div className="flex-1">
                                                <h4 className="font-semibold text-gray-900 mb-1">
                                                    {homework.title || "[Homework Title]..."}
                                                </h4>
                                                <p className="text-sm text-gray-600 mb-2">
                                                    Start Date: {homework.start_date ? new Date(homework.start_date).toLocaleDateString('en-GB', { 
                                                        day: 'numeric', 
                                                        month: 'numeric', 
                                                        year: 'numeric' 
                                                    }) : "-"}
                                                </p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-sm text-gray-600 mb-1">Due date:</p>
                                                <p className="text-sm font-medium text-gray-900">
                                                    {homework.end_date ? new Date(homework.end_date).toLocaleDateString('en-GB', { 
                                                        day: 'numeric', 
                                                        month: 'numeric', 
                                                        year: 'numeric' 
                                                    }) + ', ' + new Date(homework.end_date).toLocaleTimeString('en-GB', { 
                                                        hour: '2-digit', 
                                                        minute: '2-digit', 
                                                        hour12: true 
                                                    }) : "-"}
                                                </p>
                                            </div>
                                        </div>
                                        {homework.has_new_submissions && (
                                            <div className="absolute -top-0 right-0">
                                                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center text-gray-500 py-8">
                                No homework found for this branch
                            </div>
                        )}
                    </div>
                </div>
            ))}
            
            {/* Show message if no branches found */}
            {(!notiifications || notiifications.length === 0) && !loading && (
                <div className="panel p-8 text-center">
                    <p className="text-gray-500">No homework available</p>
                </div>
            )}
        </div>

        </>
    )
}

export default HomeworkList